var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "el-row",
          [
            _vm.saveSubmitBtnShow
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.QuotationSave,
                        expression: "QuotationSave",
                      },
                    ],
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.updateQuotation("save")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.save")))]
                )
              : _vm._e(),
            _vm.saveSubmitBtnShow
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.QuotationSave,
                        expression: "QuotationSave",
                      },
                    ],
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.updateQuotation("submit")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.submit")))]
                )
              : _vm._e(),
            _vm.estimatedAnnualFeeBtnShow
              ? _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.updateQuotation("save")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("apply.annualTotalCostSave")))]
                )
              : _vm._e(),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.historyBack },
              },
              [_vm._v(_vm._s(_vm.$t("common.close")))]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "headDataForm",
                attrs: {
                  model: _vm.headData,
                  "label-position": _vm.labelPosition,
                  "label-width": "140px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("apply.no") } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { disabled: true },
                              model: {
                                value: _vm.headData.applyNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.headData, "applyNo", $$v)
                                },
                                expression: "headData.applyNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("apply.applyType"),
                              prop: "applyType",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "handle-input",
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.headData.applyType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.headData, "applyType", $$v)
                                  },
                                  expression: "headData.applyType",
                                },
                              },
                              _vm._l(_vm.applyTypeList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: _vm._f("inputChoiceI18n")(item),
                                    value: item.code,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("apply.subject") } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { disabled: true },
                              model: {
                                value: _vm.headData.subject,
                                callback: function ($$v) {
                                  _vm.$set(_vm.headData, "subject", $$v)
                                },
                                expression: "headData.subject",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("apply.quotationType"),
                              prop: "quotationType",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "handle-input",
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.headData.quotationType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.headData, "quotationType", $$v)
                                  },
                                  expression: "headData.quotationType",
                                },
                              },
                              _vm._l(
                                _vm.quotationTypeList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm._f("inputChoiceI18n")(item),
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("common.createBy") } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { disabled: true },
                              model: {
                                value: _vm.headData.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.headData, "name", $$v)
                                },
                                expression: "headData.name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("common.createDate") } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { disabled: true },
                              model: {
                                value: _vm.headData.createDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.headData, "createDate", $$v)
                                },
                                expression: "headData.createDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-tabs",
          {
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: _vm.$t("apply.lineDetail"), name: "line" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "formTable",
                    attrs: {
                      rules: _vm.rules,
                      model: _vm.formTable,
                      inline: "",
                    },
                  },
                  [
                    _c(
                      "el-row",
                      {
                        staticStyle: { "margin-bottom": "5px" },
                        attrs: {
                          type: "flex",
                          justify: "start",
                          align: "middle",
                        },
                      },
                      [
                        _vm.saveSubmitBtnShow && _vm.headData.applyType == 2
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "价格变动比例" } },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: { type: "number" },
                                    model: {
                                      value: _vm.scale,
                                      callback: function ($$v) {
                                        _vm.scale = $$v
                                      },
                                      expression: "scale",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("%"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-row",
                              {
                                attrs: {
                                  type: "flex",
                                  justify: "start",
                                  align: "middle",
                                },
                              },
                              [
                                _vm.saveSubmitBtnShow &&
                                _vm.headData.applyType == 2
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "btn",
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                        },
                                        on: { click: _vm.batchRefresh },
                                      },
                                      [_vm._v("批量刷新")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.exportDetail()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.export")))]
                                ),
                                _vm.saveSubmitBtnShow ||
                                _vm.estimatedAnnualFeeBtnShow
                                  ? _c(
                                      "el-upload",
                                      {
                                        staticClass: "apply-import-button",
                                        attrs: {
                                          "on-error": _vm.importDetailError,
                                          "on-success": _vm.importDetailSuccess,
                                          "before-upload": _vm.beforeUpload,
                                          "show-file-list": false,
                                          action: _vm.importDetailUrl,
                                          multiple: "false",
                                          headers: _vm.headers,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "primary",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("common.import"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "ux-grid",
                      {
                        ref: "quotationLineTableDataRef",
                        attrs: {
                          data: _vm.quotationLineTableData,
                          "keep-source": "",
                          "max-height": "550",
                          "highlight-current-row": "",
                          "show-overflow": "tooltip",
                          "row-class-name": _vm.tableRowClassName,
                        },
                      },
                      [
                        _c("ux-table-column", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.saveSubmitBtnShow ||
                                !_vm.estimatedAnnualFeeEditFlag,
                              expression:
                                "saveSubmitBtnShow||!estimatedAnnualFeeEditFlag",
                            },
                          ],
                          attrs: {
                            align: "center",
                            title: "操作",
                            width: "80",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("i", {
                                    staticClass: "el-icon-edit-outline",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onEdit(scope)
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            title: "序号",
                            type: "index",
                            width: "80",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            sortable: "",
                            resizable: "",
                            title: _vm.$t("apply.supplier"),
                            field: "supplierName",
                            "min-width": "160px",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            sortable: "",
                            resizable: "",
                            title: _vm.$t("apply.shippingCity"),
                            field: "pickupPoint",
                            "min-width": "160px",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            sortable: "",
                            resizable: "",
                            title: _vm.$t("apply.arrivalAarehouse"),
                            field: "dcName",
                            "min-width": "160px",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            sortable: "",
                            resizable: "",
                            title: _vm.$t("apply.temperature"),
                            field: "temperatureI18n",
                            "min-width": "110px",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            sortable: "",
                            resizable: "",
                            title: _vm.$t("apply.transportaionMethod"),
                            field: "transportaionMethod",
                            "min-width": "120px",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("ic")(
                                          scope.row.transportaionMethod,
                                          "COMMON",
                                          "TRANSPORTAION_METHOD"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            sortable: "",
                            resizable: "",
                            title: _vm.$t("apply.unit"),
                            field: "unit",
                            "min-width": "120px",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("ic")(
                                          scope.row.unit,
                                          "COMMON",
                                          "UNIT"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            sortable: "",
                            resizable: "",
                            title: _vm.$t("apply.effectiveBeginDate"),
                            field: "effectiveBeginDate",
                            "min-width": "200px",
                          },
                        }),
                        _vm.headData.applyType == "2"
                          ? _c("ux-table-column", {
                              attrs: {
                                align: "center",
                                sortable: "",
                                resizable: "",
                                title: _vm.$t("apply.originalSupplier"),
                                field: "originalSupplier",
                                "min-width": "160px",
                              },
                            })
                          : _vm._e(),
                        _vm.headData.applyType == "2"
                          ? _c("ux-table-column", {
                              attrs: {
                                align: "center",
                                sortable: "",
                                resizable: "",
                                title: _vm.$t("apply.originalPrice"),
                                field: "originalPrice",
                                "min-width": "100",
                              },
                            })
                          : _vm._e(),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            sortable: "",
                            resizable: "",
                            title: _vm.$t("apply.priceNotTax"),
                            field: "price",
                            "min-width": "170px",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            sortable: "",
                            resizable: "",
                            title: _vm.$t("apply.currency"),
                            field: "currencyI18n",
                            "min-width": "120",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            sortable: "",
                            resizable: "",
                            title: "LeadTime",
                            field: "leadTime",
                            "min-width": "120",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            sortable: "",
                            resizable: "",
                            title: _vm.$t("apply.estimatedAnnualTotalCost"),
                            field: "estimatedAnnualFee",
                            "min-width": "160px",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            sortable: "",
                            resizable: "",
                            title: _vm.$t("common.remarks"),
                            field: "remarks",
                            "min-width": "220px",
                          },
                        }),
                        _c("ux-table-column", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.headData.quotationType == "SUP",
                              expression: "headData.quotationType=='SUP'",
                            },
                          ],
                          attrs: {
                            align: "center",
                            sortable: "",
                            resizable: "",
                            title: _vm.$t("apply.lineStatus"),
                            field: "statusI18n",
                            "min-width": "160px",
                          },
                        }),
                        _c("ux-table-column", {
                          attrs: {
                            align: "center",
                            sortable: "",
                            resizable: "",
                            title: _vm.$t("apply.lineType"),
                            field: "lineType",
                            "min-width": "160px",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("common.attachment"),
                  name: "enclosure",
                },
              },
              _vm._l(_vm.supplierList, function (supplier, ix) {
                return _c(
                  "el-row",
                  { key: ix, attrs: { align: "middle", gutter: 10 } },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _vm._v(" " + _vm._s(supplier.supplierCode) + " "),
                    ]),
                    _c(
                      "el-col",
                      { attrs: { span: 20 } },
                      [
                        _c(
                          "el-table",
                          {
                            staticClass: "table",
                            attrs: {
                              data: _vm.fileList[ix],
                              border: "",
                              "highlight-current-row": "",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": "",
                                sortable: "",
                                prop: "documentName",
                                label: _vm.$t("common.file"),
                                "min-width": "130px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.downloadFile(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.documentName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": "",
                                sortable: "",
                                prop: "userName",
                                label: _vm.$t("common.createBy"),
                                "min-width": "130px",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": "",
                                sortable: "",
                                prop: "createDate",
                                label: _vm.$t("common.createDate"),
                                "min-width": "130px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("dateFormatFilter")(
                                                scope.row.createDate,
                                                "YYYY-MM-DD HH:mm"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm.showUploadFlag
                              ? _c("el-table-column", {
                                  attrs: {
                                    "show-overflow-tooltip": "",
                                    prop: "tmDocumentId",
                                    "min-width": "130px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-link",
                                              {
                                                attrs: { type: "primary" },
                                                nativeOn: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.deleteFile(
                                                      scope.row.tmDocumentId,
                                                      scope.$index,
                                                      _vm.fileList[ix]
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("common.del"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm.showUploadFlag
                          ? _c(
                              "el-upload",
                              {
                                ref: "upload",
                                refInFor: true,
                                staticStyle: { float: "left" },
                                attrs: {
                                  action: "upload",
                                  "http-request": _vm.uploadConfirm,
                                  multiple: "",
                                  "on-remove": _vm.removeFile,
                                  "file-list": _vm.showFileList,
                                  name: "file",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      slot: "trigger",
                                      size: "mini",
                                      type: "primary",
                                    },
                                    slot: "trigger",
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.selectFile")))]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.showUploadFlag
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "15px" },
                                attrs: { size: "mini", type: "success" },
                                on: {
                                  click: function ($event) {
                                    return _vm.submitUpload(
                                      supplier.tmSupplierId,
                                      ix
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("common.upload")))]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "报价明细",
              visible: _vm.dialogEditVisible,
              width: "80%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogEditVisible = $event
              },
              close: _vm.onCancel,
            },
          },
          [
            _c(
              "el-table",
              {
                ref: "tableDataRef",
                attrs: {
                  data: _vm.tableData,
                  border: "",
                  "highlight-current-row": "",
                  "max-height": "470",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    sortable: "",
                    prop: "supplierName",
                    label: _vm.$t("apply.supplier"),
                    "min-width": "160px",
                    fixed: "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "pickupPoint",
                    label: _vm.$t("apply.shippingCity"),
                    "min-width": "160px",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "dcName",
                    label: _vm.$t("apply.arrivalAarehouse"),
                    "min-width": "160px",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "temperatureI18n",
                    label: _vm.$t("apply.temperature"),
                    "min-width": "110px",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "transportaionMethod",
                    label: _vm.$t("apply.transportaionMethod"),
                    "min-width": "120px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: scope.row.transportaionMethod,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "transportaionMethod",
                                    $$v
                                  )
                                },
                                expression: "scope.row.transportaionMethod",
                              },
                            },
                            _vm._l(
                              _vm.transportaionMethodList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: _vm._f("inputChoiceI18n")(item),
                                    value: item.code,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "unit",
                    label: _vm.$t("apply.unit"),
                    "min-width": "120px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: scope.row.unit,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "unit", $$v)
                                },
                                expression: "scope.row.unit",
                              },
                            },
                            _vm._l(_vm.unitList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm._f("inputChoiceI18n")(item),
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "effectiveBeginDate",
                    label: _vm.$t("apply.effectiveBeginDate"),
                    "min-width": "200px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.headData.applyType == "2"
                            ? _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "picker-options": _vm.dateLimit,
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  placeholder: _vm.$t("common.selDate"),
                                },
                                model: {
                                  value: scope.row.effectiveBeginDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      scope.row,
                                      "effectiveBeginDate",
                                      $$v
                                    )
                                  },
                                  expression: "scope.row.effectiveBeginDate",
                                },
                              })
                            : _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  placeholder: _vm.$t("common.selDate"),
                                },
                                model: {
                                  value: scope.row.effectiveBeginDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      scope.row,
                                      "effectiveBeginDate",
                                      $$v
                                    )
                                  },
                                  expression: "scope.row.effectiveBeginDate",
                                },
                              }),
                        ]
                      },
                    },
                  ]),
                }),
                _vm.headData.applyType == "2"
                  ? _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        prop: "originalSupplier",
                        label: _vm.$t("apply.originalSupplier"),
                        "min-width": "160px",
                      },
                    })
                  : _vm._e(),
                _vm.headData.applyType == "2"
                  ? _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        prop: "originalPrice",
                        label: _vm.$t("apply.originalPrice"),
                        "min-width": "80px",
                      },
                    })
                  : _vm._e(),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "price",
                    label: _vm.$t("apply.priceNotTax"),
                    width: "170px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-input", {
                            on: {
                              blur: function ($event) {
                                return _vm.setPrice(
                                  scope.row.price,
                                  scope.$index
                                )
                              },
                            },
                            model: {
                              value: scope.row.price,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "price", $$v)
                              },
                              expression: "scope.row.price",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "tcCurrencyId",
                    label: _vm.$t("apply.currency"),
                    width: "160px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              attrs: { filterable: true },
                              on: {
                                change: function ($event) {
                                  return _vm.currencyChange($event, scope.row)
                                },
                              },
                              model: {
                                value: scope.row.tcCurrencyId,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "tcCurrencyId", $$v)
                                },
                                expression: "scope.row.tcCurrencyId",
                              },
                            },
                            [
                              _c("el-option", { attrs: { value: "" } }, [
                                _vm._v(_vm._s(_vm.$t("common.pleaseSelect"))),
                              ]),
                              _vm._l(_vm.currencyList, function (item, index) {
                                return _c("el-option", {
                                  key: index + 1,
                                  attrs: {
                                    label: item.currencyCode,
                                    value: item.tcCurrencyId,
                                  },
                                })
                              }),
                            ],
                            2
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "leadTime",
                    label: "LeadTime",
                    width: "160px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-input", {
                            model: {
                              value: scope.row.leadTime,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "leadTime", $$v)
                              },
                              expression: "scope.row.leadTime",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "estimatedAnnualFee",
                    label: _vm.$t("apply.estimatedAnnualTotalCost"),
                    width: "160px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-input", {
                            attrs: { disabled: _vm.estimatedAnnualFeeEditFlag },
                            model: {
                              value: scope.row.estimatedAnnualFee,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "estimatedAnnualFee", $$v)
                              },
                              expression: "scope.row.estimatedAnnualFee",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "remarks",
                    label: _vm.$t("common.remarks"),
                    width: "220px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-input", {
                            model: {
                              value: scope.row.remarks,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "remarks", $$v)
                              },
                              expression: "scope.row.remarks",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.headData.quotationType == "SUP",
                      expression: "headData.quotationType=='SUP'",
                    },
                  ],
                  attrs: {
                    prop: "statusI18n",
                    label: _vm.$t("apply.lineStatus"),
                    "min-width": "160px",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    sortable: "",
                    prop: "lineType",
                    label: _vm.$t("apply.lineType"),
                    width: "160px",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
                  [_vm._v("确认")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onCancel } },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }